import React, {useState} from 'react';
import {getProductLabel} from "../../libs/productLabel";
import {User, StripeProduct, Group} from "fearless-common";
import Modal from "react-bootstrap/Modal";
import SubscriptionCard from "../subscriptions/SubscriptionCard";
import {adminRoutes} from "../../utils/routes";
import {BoxArrowUpRight} from "react-bootstrap-icons";
import Button from "react-bootstrap/Button";
import Photo51SubscriptionSwitcher from "../subscriptions/Photo51SubscriptionSwitcher";

const notSubscribed = <i className="neutral-300">not subscribed</i>;


export default function AdminUserSubscriptionInfo({ user }: { user: User & { groups: Group[] };}) {
  const [showProduct, setProductToShow] = useState<StripeProduct | null>();

  const { subscription_per_product: subscriptionPerProduct } = user;

  return subscriptionPerProduct ? (
    <table className="table table-sm">
      <thead>
      <tr>
        <th>Product</th>
        <th>Method</th>
      </tr>
      </thead>
      <tbody>
      {[StripeProduct.photo51, StripeProduct.eln, StripeProduct.lims].map((product) => {
        const subscription = subscriptionPerProduct[product]?.subscription;
        const group = subscriptionPerProduct[product]?.group;
        const rule = subscriptionPerProduct[product]?.rule;
        const via = subscriptionPerProduct[product]?.via;
        return (
          <tr key={product}>
            <td>{getProductLabel(product)}</td>
            <td>
              <span className="me-2">
                {via
                  ? <>{via} {group && <a href={adminRoutes.group(group.id)}>{group.name}</a>}</>
                  : notSubscribed}
              </span>
                {subscription && <Button size="sm" onClick={() => setProductToShow(product)}>Show</Button>}
              {subscription && showProduct === product && (
                <Modal show size="lg" onHide={() => setProductToShow(null)}>
                  <Modal.Header closeButton>
                    <Modal.Title>Subscription</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <SubscriptionCard subscription={subscription} group={group} />
                    <hr />
                    <Photo51SubscriptionSwitcher onSuccess={() => {}} user={user} />
                  </Modal.Body>
                </Modal>
              )}
              {via === 'rule' && rule && (
                <a href={adminRoutes.subscriptionRule(rule.id)}>
                  <BoxArrowUpRight />
                </a>
              )}
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  ) : null;
}
